  const imgs = document.querySelectorAll('.pay_type_pic');
  if (imgs.length) {
    const closeDom = document.getElementsByClassName('pay-fixed-close')[0];
    
    const payFixedDom = document.getElementsByClassName('pay-fixed')[0];
    const body = document.body;
    
    for (let i = 0; i < imgs.length; i++) {
      imgs[i].onclick = function () {
        payFixedDom.classList.remove('hide-fiexed');
        scrollTop = body.scrollTop;
        body.style.overflow = 'hidden';
        body.style.height = '100vh';
      };
    }

    closeDom.onclick = function () {
      payFixedDom.classList.add('hide-fiexed');
      body.scrollTop = scrollTop;
      body.style.overflow = 'auto';
      body.style.height = 'auto';
    };

  }


// 获取模态和按钮元素
var modal = document.getElementById("myModal");
var modal_01 = document.getElementById("myModal_01");
var btn = document.getElementById("ProductPopup-price");

var myclose = document.getElementById("myClose");
const closeDom2 = document.getElementsByClassName('pay-fixed-close2')[0];

// 打开模态的函数
btn.onclick = function() {
  modal.style.display = "block";
}

// 点击关闭按钮或背景关闭模态的函数
closeDom2.onclick = function() {
  modal.style.display = "none";
  console.log('aaa');
}

// 点击模态背景时关闭模态的函数（可选）
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}  